import { render, staticRenderFns } from "./LegoControlCardAdjuntos.vue?vue&type=template&id=2143d7f7"
import script from "./LegoControlCardAdjuntos.vue?vue&type=script&lang=js"
export * from "./LegoControlCardAdjuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports